import { FileText, Loader2, Presentation, Check, CircleDashed, LoaderCircle } from 'lucide-react';
import { Lesson } from '@/types/course-outline';

interface LessonItemProps {
  lesson: Lesson;
  onClick?: () => void;
}

const LessonItem = ({ lesson, onClick }: LessonItemProps) => {
  const isGenerating = lesson.status === 'generating' || lesson.status === 'pending';
  const isFailed = lesson.status === 'failed';
  
  return (
    <div 
      className={`flex items-center justify-between rounded-xl border border-border px-3.5 py-2.5 bg-white transition-colors ${
        isGenerating || isFailed ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer hover:bg-[#F9FAFB]'
      }`}
      style={{ fontFamily: 'Lexend Deca' }}
      onClick={isGenerating || isFailed ? undefined : onClick}
    >
      {/* Left Side */}
      <div className="flex items-center gap-4">
        {/* Icon */}
        <div className="flex items-center justify-center flex-shrink-0">
          {isGenerating ? (
            <Loader2 className="w-6 h-6 animate-spin" style={{ color: '#666666' }} strokeWidth={2} />
          ) : (
            <Presentation className="w-6 h-6" style={{ color: '#666666' }} strokeWidth={2} />
          )}
        </div>

        {/* Title and Lesson Number */}
        <div className="flex flex-col gap-1">
          <p className="text-[14px] font-medium" style={{ color: 'rgba(0,0,0,0.6)' }}>
            {lesson.title}
          </p>
          <p className="text-xs text-muted-foreground">
            {isGenerating ? 'Generating...' : isFailed ? 'Failed' : `Lesson ${lesson.lessonNumber}`}
          </p>
        </div>
      </div>

      {/* Right Side */}
      <div className="flex items-center gap-2 flex-shrink-0">
        <span className="text-xs text-muted-foreground">
          {lesson.duration}
        </span>
        {lesson.completed ? (
          <div className="w-[24px] h-[23px] rounded-full bg-black flex items-center justify-center">
            <Check className="w-3 h-3 text-white" strokeWidth={2} />
          </div>
        ) : lesson.completionPercentage && lesson.completionPercentage > 0 ? (
          <LoaderCircle className="w-[24px] h-[23px] text-black" strokeWidth={1.67} />
        ) : (
          <CircleDashed className="w-[24px] h-[23px] text-black" strokeWidth={1.67} />
        )}
      </div>
    </div>
  );
};

export default LessonItem;
